// extracted by mini-css-extract-plugin
export default {"settings":"swGIYvAe9ZUBaeNCCWjL+w==","messagesWrapper":"WfXsT7tLK+UJ-hA+OTkqxw=="};